// Registers the service worker and exposes a hook for "new version available".
// Runs only in production (CRA dev mode interferes with HMR).

export function registerServiceWorker(onUpdate) {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // CRA dev server (localhost:3000 with HMR) — skip SW to avoid stale dev assets
  if (process.env.NODE_ENV === "development") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Listen for updates
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // A new SW is waiting; notify the app
              if (typeof onUpdate === "function") onUpdate(reg);
            }
          });
        });
      })
      .catch(() => {
        /* swallow — SW failures must not break the app */
      });

    // Auto-reload once a new SW takes control (after we tell it to skip waiting)
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function unregisterServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}
